import { i18n } from '@secret-escapes/i18n';
import * as React from 'react';
import { TranslationsContext } from '../../common/contexts';
import { IAddress, IOccupancy } from '../../common/types/apiSchema';

/**
 * Formats the hotel address as a string
 * @param hotelAddress IAddress containing hotel address
 */
export function getHotelAddressString(hotelAddress: IAddress): string {
  let hotelAddressString: string = hotelAddress.line1;
  if (hotelAddress.line2) {
    hotelAddressString = hotelAddressString.concat(`, ${hotelAddress.line2}`);
  }
  if (hotelAddress.line3) {
    hotelAddressString = hotelAddressString.concat(`, ${hotelAddress.line3}`);
  }
  if (hotelAddress.line4) {
    hotelAddressString = hotelAddressString.concat(`, ${hotelAddress.line4}`);
  }
  if (hotelAddress.line5) {
    hotelAddressString = hotelAddressString.concat(`, ${hotelAddress.line5}`);
  }

  return hotelAddressString;
}

/**
 * Formats occupancy details as a string
 * @param occupancy Occupancy details to format
 */
export function getOccupancyString(occupancy: IOccupancy): string {
  const { translations } = React.useContext(TranslationsContext);

  if (!occupancy) {
    return '';
  }

  let occupancyString: string = i18n(
    'common.numberOfAdults.text',
    [occupancy.adults],
    translations
  );
  if (occupancy.children > 0) {
    occupancyString = occupancyString.concat(
      `, ${i18n('common.numberOfChildren.text', [occupancy.children], translations)}`
    );
  }

  occupancyString = occupancyString.concat(', ');

  return occupancyString;
}
